var map = {
	"./00_booking-com.png": 77058,
	"./01_hrs.png": 10406,
	"./02_expedia.png": 9715,
	"./03_priceline.png": 78746,
	"./04_airbnb_logo.png": 26652,
	"./04_easytobook_@2x.png": 97418,
	"./05_amadeus.png": 27726,
	"./06_hotelbeds_.png": 53356,
	"./08_go-global-travel.png": 60608,
	"./09_laterooms_@2x.png": 21223,
	"./10_hotel.de.png": 35385,
	"./11_aic-group.png": 70154,
	"./12_miki-travel.png": 47803,
	"./13_travco_@2x.png": 2894,
	"./14_ezeego.png": 50549,
	"./15_serhs-tourism.png": 31478,
	"./16_getabed.png": 45792,
	"./17_getaroom.png": 10940,
	"./18_sidetours.png": 3502,
	"./19_specialtours.png": 53683,
	"./20_gogo-travel.png": 8178,
	"./22-globest.com.png": 92261,
	"./23_sunhotels.png": 4735,
	"./24_bedbank.png": 58581,
	"./25_tbo.png": 90952,
	"./26_teldar-travel.png": 92561,
	"./27_thomas-cook.png": 53749,
	"./28_hoteldo.png": 30990,
	"./32_hotelston.png": 67081,
	"./33_transhotel.png": 69491,
	"./34_gekkogroup.png": 31904,
	"./35_travalco.png": 4206,
	"./36_italcamel.png": 33228,
	"./37_jactravel.png": 9823,
	"./39_kuoni.png": 85101,
	"./40_travelguru.png": 22640,
	"./41_travellanda.png": 52157,
	"./45_veturis.png": 43839,
	"./46_makemytrip.png": 72041,
	"./47_wtm.png": 72838,
	"./49_welcomebeds.png": 18128,
	"./50_methabook.png": 6493,
	"./51_whl-travel.png": 75937,
	"./52_ehotel.png": 37303,
	"./53_dhisco-Rategain.png": 5077,
	"./54_radius.png": 33030,
	"./55-rooms-xml.png": 20640,
	"./56_gta.png": 53458,
	"./58_abreu.png": 59385,
	"./60_actours.png": 81245,
	"./61_asa.png": 56605,
	"./62_mts.png": 65472,
	"./63_bedsonline.png": 51059,
	"./64_olympia-europe.png": 76416,
	"./66_orbitz.png": 25739,
	"./67_bonotel.png": 83988,
	"./69_darina.png": 18121,
	"./70_restel.png": 38089,
	"./71_ebookers.png": 25826,
	"./71_rts.png": 30584,
	"./73_sabre.png": 20908,
	"./74_escala.png": 51417,
	"./76_dotw.png": 31450,
	"./77_CTN-CustomTravelNetwork.png": 86598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99691;